<template>
<!-- <page-banner :pageNumber='5'></page-banner>-->
  <crumbs />
  <div class="mainContainer">
    <show-content :detail = 'detail'></show-content>
  </div>
</template>

<script setup>
  import {findEngineeringProjectDetailById, findInnovateBusinessDetailById} from '/apis/ywtx.js'
  
  const route = useRoute()
  const detailId = ref(route.params.id)
  const axios = ref()

  // console.log(route.query.from)
  // /ywtx/gcjs
  if (route.query.from && route.query.from.includes('ywtx/gcjs')) {
    axios.value = findEngineeringProjectDetailById({EngineeringProjectId:detailId})
  } else {
    axios.value = findInnovateBusinessDetailById({InnovateBusinessId:detailId})
  }

  
  /**
   * @description: 获取工程建设信息
   * */
  const detail = ref({});
  const detailRes = await useAsyncData('findEngineeringProjectDetailById', () => axios.value )
  if (detailRes.data.value.code !== 200) {
    throw createError({
      statusCode: detailRes.data.value.code,
      statusMessage: encodeURIComponent("获取工程建设信息失败")
    })
  } else {
    // console.log(111)
    detail.value = detailRes.data.value.data
  }
  // console.log(detail.value)
  useHead({
    title: `${detail.value.contentTitle} - 郑州路桥建设投资集团有限公司`,
  })
</script>

<style>
</style>